import { HttpRequest } from '../../../../../types/rest/analyticsTypes';
import { DetailTabType } from '../../analyticsUiTypes';

export const SELECT_WEBHOOK_VIEW_TRIGGER = 'SELECT_WEBHOOK_VIEW_TRIGGER';
export const SET_WEBHOOK_VIEW_ACTIVE_PAGE = 'SET_WEBHOOK_VIEW_ACTIVE_PAGE';
export const SET_WEBHOOK_VIEW_PAGE_SIZE = 'SET_WEBHOOK_VIEW_PAGE_SIZE';
export const SET_WEBHOOK_SEARCH_KEYWORD = 'SET_WEBHOOK_SEARCH_KEYWORD';
export const SELECT_WEBHOOK_DETAIL_TAB = 'SELECT_WEBHOOK_DETAIL_TAB';

export type SelectWebhookViewTrigger = {
  type: typeof SELECT_WEBHOOK_VIEW_TRIGGER;
  payload: HttpRequest | null;
};
export type ChangeWebhookActivePage = {
  type: typeof SET_WEBHOOK_VIEW_ACTIVE_PAGE;
  payload: number;
};
export type ChangeWebhookPageSize = {
  type: typeof SET_WEBHOOK_VIEW_PAGE_SIZE;
  payload: number;
};
export type SetWebhookSearchKeyword = {
  type: typeof SET_WEBHOOK_SEARCH_KEYWORD;
  payload: string;
};
export type SelectWebhookDetailTab = {
  type: typeof SELECT_WEBHOOK_DETAIL_TAB;
  payload: DetailTabType;
};
export type WebhookViewActionTypes =
  | SelectWebhookViewTrigger
  | ChangeWebhookActivePage
  | ChangeWebhookPageSize
  | SetWebhookSearchKeyword
  | SelectWebhookDetailTab;
